import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { DateFormatter, ROTUES } from "../../utils/global";
import {
  getAllProjectsApiCall,
  getUserApiCall,
  getUsersApiCall,
  updateProjectAction,
} from "../../store/actions/projectAction";
import TextField from "../Partial/TextField";
import Select from "react-select";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import Button from "../Partial/Button";
import { format } from "date-fns";
import $ from "jquery";
import moment from "moment";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";

const statusOptions = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Production",
    value: "in_production",
  },

  {
    label: "Production complete",
    value: "production_complete",
  },
  {
    label: "Shipment",
    value: "shipment",
  },

  {
    label: "Completed",
    value: "completed",
  },
];

const statusOptionsMapping = [
  {
    label: "Designing",
    value: "design",
  },
  {
    label: "Design Verification",
    value: "design_varification",
  },

  {
    label: "Order Placed",
    value: "order_placed",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Production",
    value: "in_production",
  },

  {
    label: "Production complete",
    value: "production_complete",
  },
  {
    label: "Shipment",
    value: "shipment",
  },

  {
    label: "Completed",
    value: "completed",
  },
];

function ProjectTable() {
  const users = useSelector((state) => state.project.users);
  const navigate = useNavigate();
  const [value, setValue] = useState(null);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [selectedStatus, setSelectedStatus] = React.useState(null);

  const dateInputRef = useRef();

  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);

  const [data, setData] = useState({
    totalDesigns: 0,
    totalOrders: 0,
    totalProjects: 0,
  });

  const [dropdownIndex, setDropdownIndex] = useState(null);
  const dropdownRef = useRef(null);

  const today = new Date();
  const twoWeeksAgo = new Date();
  twoWeeksAgo.setDate(today.getDate() - 14);

  const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useDispatch();

  const toggleDropdown = (e, index) => {
    e.stopPropagation();
    setDropdownIndex(index === dropdownIndex ? null : index);
  };

  const handleSelect = (value) => {
    setValue(value);
  };

  const handleChange = (selected) => {
    setSelectedOption(selected);
  };

  const handleChangeStatus = (selected) => {
    setSelectedStatus(selected);
  };

  const fetchApiCall = async (date = null) => {
    let input = {
      search: debouncedQuery,
    };

    if (dateRange?.startDate && dateRange?.endDate) {
      input["startDate"] = dateRange.startDate.toDate();
      input["endDate"] = dateRange.endDate.toDate();
    }

    if (selectedOption?.value) {
      input["user"] = selectedOption?.value;
    }

    if (selectedStatus) {
      input["status"] = selectedStatus?.value;
    }

    dispatch(getAllProjectsApiCall(input))
      .unwrap()
      .then((data) => {
        setProjects(data?.doc);
        setFilteredProjects(data?.doc);
        setData({
          totalDesigns: data?.total_designs,
          totalOrders: data?.total_final_orders,
          totalProjects: data?.total_projects,
        });
      });
  };

  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  const handleStatusChange = (id, status) => {
    dispatch(
      updateProjectAction({
        id: id,
        status: status?.value,
      })
    )
      .unwrap()
      .then(() => {
        fetchApiCall();
        setDropdownIndex(null);
      });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  useEffect(() => {
    fetchApiCall();
  }, [debouncedQuery, dateRange, selectedOption, selectedStatus]);

  useEffect(() => {
    dispatch(getUsersApiCall({}));
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownIndex(null); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (!dateInputRef.current) return;

    $(dateInputRef.current).daterangepicker(
      {
        autoUpdateInput: false, // Don't auto-fill input
        locale: {
          format: "YYYY-MM-DD",
          cancelLabel: "Clear",
        },
      },
      (start, end) => {
        setDateRange({ startDate: start, endDate: end });
        $(dateInputRef.current).val(`${start.format("YYYY-MM-DD")} - ${end.format("YYYY-MM-DD")}`);
      }
    );

    // Handle cancel/clear
    $(dateInputRef.current).on("cancel.daterangepicker", function () {
      $(this).val("");
      setDateRange({ startDate: null, endDate: null });
    });

    return () => {
      $(dateInputRef.current).data("daterangepicker")?.remove(); // Cleanup
    };
  }, []);

  const options = useMemo(() => {
    return users?.map((item) => {
      return {
        label: item?.name,
        value: item?._id,
      };
    });
  }, [users]);

  return (
    <div className="w-full flex justify-center mt-24">
      <div className="w-[95%] flex flex-col gap-6">
        <div className="flex  items-center gap-5">
          <p className="text-2xl">Projects</p>

          <div style={{ position: "relative", width: 300 }}>
            {/* Date Picker */}
            <div className="relative w-72">
              <input
                ref={dateInputRef}
                className="border px-4 py-2 rounded w-full"
                readOnly
                placeholder="Select date range"
              />
            </div>
          </div>

          <div className="border w-80">
            <TextField
              placeholder="Search projects."
              name="query"
              onChange={handleSearch}
            />
          </div>
          <div className="border w-80">
            <Select
              value={selectedOption}
              onChange={handleChange}
              options={options}
              isClearable
              className="text-sm"
              placeholder="Select user"
            />
          </div>

          <div className="border w-80">
            <Select
              value={selectedStatus}
              onChange={handleChangeStatus}
              options={statusOptionsMapping}
              isClearable
              className="text-sm"
              placeholder="Select status"
            />
          </div>
        </div>

        <div className="flex flex-col gap-10">
          <div className="w-full flex">
            <div className="w-full mt-10 grid grid-cols-3 gap-6 ">
              <div className="bg-white h-40 shadow-sm rounded-lg p-6 text-center flex flex-col justify-center">
                <h2 className="text-xl font-semibold text-gray-700">
                  Total Projects
                </h2>
                <p className="text-4xl font-bold text-[#00428c]">
                  {data.totalProjects}
                </p>
              </div>

              <div className="bg-white h-40 shadow-sm rounded-lg p-6 text-center flex flex-col justify-center">
                <h2 className="text-xl font-semibold text-gray-700">
                  Total Designs
                </h2>
                <p className="text-4xl font-bold text-[#00428c]">
                  {data.totalDesigns}
                </p>
              </div>
              <div className="bg-white h-40 shadow-sm rounded-lg p-6 text-center flex flex-col justify-center">
                <h2 className="text-xl font-semibold text-gray-700">
                  Total Orders
                </h2>
                <p className="text-4xl font-bold text-[#00428c]">
                  {data.totalOrders}
                </p>
              </div>
            </div>
          </div>

          <table className="min-w-full bg-white">
            <thead>
              <tr>
                <th className="px-4 py-4 border-b text-left">Date</th>
                <th className="px-4 py-4 border-b text-left">Project Name</th>
                <th className="px-4 py-4 border-b text-left">Client Name</th>
                <th className="px-4 py-4 border-b text-left">
                  Client phone no.{" "}
                </th>
                <th className="px-4 py-4 border-b text-left">Pincode</th>
                <th className="px-4 py-4 border-b text-left">Status</th>
                <th className="px-4 py-4 border-b text-left">Notes</th>
                <th className="px-4 py-4 border-b text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredProjects.map((project, index) => {
                const statusLabel = statusOptionsMapping?.find(
                  (item) => item?.value == project?.status
                );

                return (
                  <tr key={project?._id} className="hover:bg-gray-100">
                    <td className="px-4 py-4 border-b">
                      {DateFormatter(project?.createdAt)}
                    </td>
                    <td className="px-4 py-4 border-b">{project.name}</td>

                    <td className="px-4 py-4 border-b">
                      {project.client_name}
                    </td>

                    <td className="px-4 py-4 border-b">
                      {project?.client_phone}
                    </td>
                    <td className="px-4 py-4 border-b">{project?.postcode}</td>
                    <td className="px-4 py-4 border-b">{statusLabel?.label}</td>

                    <td className="px-4 py-4 border-b">
                      <div className="max-w-md">{project.notes}</div>
                    </td>

                    <td className="px-4 py-4 border-b">
                      <div className="flex gap-5">
                        <Link
                          to={`${ROTUES.downloadPdf}/${project?._id}`}
                          className="text-blue-500 hover:text-blue-700"
                        >
                          ⬇️
                        </Link>
                        <div className="relative">
                          <button
                            className="text-blue-500 hover:text-blue-700"
                            onClick={(e) => toggleDropdown(e, index)}
                          >
                            Change Status
                          </button>
                          {dropdownIndex === index && (
                            <div
                              className="absolute left-[-137px] bg-white border shadow rounded mt-2 z-10"
                              ref={dropdownRef}
                            >
                              {statusOptions.map((status) => (
                                <button
                                  key={status?.value}
                                  className="block px-4 py-2 text-left hover:bg-gray-100 w-52"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleStatusChange(project?._id, status);
                                  }}
                                >
                                  {status.label}
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!filteredProjects?.length ? (
            <div className="w-full flex justify-center mt-3">
              <p>No data found.</p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ProjectTable;
